import React from 'react';
import { Typography, Card, Grid, CardHeader } from '@mui/material';

import { Colors } from '../utils/Colors';
import { OcdTypeNoCloudImages, OCDTypeToImage } from '../utils/Icons';
import { KebabMenu } from './KebabMenu';

function HeaderComponent({ obsessionType, isSelected, menuItems }: any) {
  return (
    <Grid
      container
      item
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      style={{
        backgroundColor: `${isSelected ? Colors.skobeloff : Colors.lightGray}`,
        height: '80px'
      }}
    >
      <Grid container item xs={3} justifyContent="center">
        {React.cloneElement(
          OcdTypeNoCloudImages[OCDTypeToImage(obsessionType)],
          { style: { height: '80px' } }
        )}
      </Grid>
      <Grid container item xs={6} justifyContent="center">
        <Typography
          align="left"
          style={{
            color: `${isSelected ? Colors.ocdWhite : Colors.richBlack}`,
            fontSize: '20px',
            fontWeight: 'bold'
          }}
        >
          {obsessionType ?? 'Task'}
        </Typography>
      </Grid>
      <Grid container item xs={3} justifyContent="center">
        <KebabMenu menuItems={menuItems} />
      </Grid>
    </Grid>
  );
}

export function GenericObsessionTypeCard({
  obsessionType,
  cardInfo,
  onClick = () => {},
  isSelected,
  menuItems
}: any) {
  // const Header = React.useMemo(
  //   () => React.forwardRef<any>((
  //     headerProps,
  //     ref,
  //     // eslint-disable-next-line react/jsx-props-no-spreading
  //   ) => <HeaderComponent {...headerProps} ref={ref} />),
  //   [obsessionType, menuItems],
  // );
  return (
    <Card
      onClick={onClick}
      sx={{
        minWidth: '125px',
        minHeight: '150px',
        padding: '0',
        border: `1px solid ${Colors.silverSand}`,
        borderRadius: '15px',
        boxShadow: 0,
        backgroundColor: `${Colors.lightGray}`
      }}
    >
      <CardHeader
        component={HeaderComponent}
        menuItems={menuItems}
        obsessionType={obsessionType}
        isSelected={isSelected}
      />
      <Grid
        container
        direction="column"
        textAlign="center"
        style={{
          padding: '15px',
          minWidth: '275px',
          maxWidth: '275px',
          fontSize: '14px',
          color: Colors.richBlack
        }}
      >
        <Grid
          container
          item
          direction="row"
          textAlign="left"
          style={{ padding: '0px 25px' }}
        >
          {cardInfo.map((info: any) => (
            <Grid
              key={`${info.title}${info.description}`}
              container
              item
              direction="row"
            >
              <Grid item xs={1}>
                <Typography style={{ color: Colors.skobeloff }}>
                  {`${info.title}:`}
                </Typography>
              </Grid>
              <Grid
                item
                xs={11}
                style={{ color: info.color ? info.color : 'inherit' }}
              >
                <Typography>{info.description}</Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Card>
  );
}
